import MetricBadge from './MetricBadge.jsx';

/**
 * @param {{ items: Array<{ id?:string, severity?:string, title:string, detail?:string }> }} props
 */
export default function AlertList({ items, emptyLabel = 'Sin alertas activas.' }) {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) {
    return <p className="analytics-empty">{emptyLabel}</p>;
  }
  return (
    <ul className="analytics-alert-list">
      {list.map((a, i) => (
        <li key={a.id || i} className={'analytics-alert-item is-' + (a.severity || 'warn')}>
          <MetricBadge tone={a.severity === 'bad' ? 'bad' : a.severity === 'ok' ? 'ok' : 'info'}>
            {(a.severity || 'warn').toUpperCase()}
          </MetricBadge>
          <div>
            <strong>{a.title}</strong>
            {a.detail ? <p>{a.detail}</p> : null}
          </div>
        </li>
      ))}
    </ul>
  );
}
